function toFiniteNumber(v: unknown): number | null {
  if (v == null) {
    return null;
  }
  if (typeof v === 'number') {
    return Number.isFinite(v) ? v : null;
  }
  if (typeof v === 'string') {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }
  // BigQueryInt-like object with .value
  if (typeof v === 'object' && v !== null && 'value' in (v as Record<string, unknown>)) {
    const inner = (v as { value: unknown }).value;
    if (typeof inner === 'string') {
      const n = Number(inner);
      return Number.isFinite(n) ? n : null;
    }
    if (typeof inner === 'number') {
      return Number.isFinite(inner) ? inner : null;
    }
  }
  return null;
}

export function num(v: unknown): string {
  const n = toFiniteNumber(v);
  return n == null ? '—' : n.toLocaleString();
}

export function compact(v: unknown): string {
  const n = toFiniteNumber(v);
  if (n == null) {
    return '—';
  }
  if (n >= 1_000_000) {
    return `${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M`;
  }
  if (n >= 1_000) {
    return `${(n / 1_000).toFixed(n >= 10_000 ? 0 : 1)}K`;
  }
  return n.toLocaleString();
}

export function pct(v: unknown, d: unknown): string {
  const num = toFiniteNumber(v);
  const den = toFiniteNumber(d);
  if (num == null || den == null || den === 0) {
    return '—';
  }
  return `${((num / den) * 100).toFixed(1)}%`;
}
